// extracted by css-extract-rspack-plugin
export default {"title":"_c3bb212c","description":"_666b78ca"};